module.exports = __webpack_public_path__ + "img/1591971466.fde4c3c8.jpg";